// app/javascript/bank_accounts/poll_status.js
class BankAccountPoller {
    constructor() {
        this.$form = $('form');
        this.$submitButton = this.$form.find('button[type="submit"]');
        this.$status = $('.verification-status');
        this.$accountNumberInput = this.$form.find('#investors_bank_account_form_account_number');
        this.oneTimeSurepayCountries = this.$accountNumberInput.data('oneTimeSurepayCountries');
        this.maxAttempts = 30;
        this.attempts = 0;
    }

    start() {
        this.disableForm();
        this.poll = setInterval(() => this.checkStatus(), 2000);
    }

    checkStatus() {
        this.attempts++;

        $.ajax({
            url: '/account/bank-account',
            method: 'GET',
            dataType: 'json',
            headers: {
                'Accept': 'application/json'
            }
        })
            .done((data) => {
                if (data.status !== 'processing' || this.attempts >= this.maxAttempts) {
                    this.stop();

                    if (data.status === 'verified' || data.status === 'waiting_for_sepa_validation_payment') {
                        window.location.href = data.redirect_url;
                    } else {
                        if (data.status === 'surepay_verification_failed') {
                            if (this.isOneTimeSurepayCountry()) {
                                $('.sepa-mandate-wrapper').show();
                            } else {
                                $.flash('alert', data.name_suggestion);
                            }
                        } else {
                            if (this.attempts > this.maxAttempts){
                                $.flash('alert', this.$form.data('verificationTimeout'));
                            }
                        }
                        this.reactivateForm();
                    }
                }
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                this.stop();
                const errorMessage = this.$form.data('verificationError');
                $.flash('alert', errorMessage);
                this.reactivateForm();
            });
    }

    stop() {
        clearInterval(this.poll);
    }

    disableForm() {
        if (this.$form.length) {
            this.$form.addClass('processing');
            this.$submitButton.prop('disabled', true);
            this.$status.removeClass('d-none');
            this.$form.attr('aria-busy', 'true');
        }
    }

    reactivateForm(errorMessage) {
        if (this.$form.length) {
            this.$form.removeClass('processing');
            this.$submitButton.prop('disabled', false);
            this.$status.addClass('d-none');
            this.$form.attr('aria-busy', 'false');
        }
    }

    isOneTimeSurepayCountry() {
        const accountNumber = this.$accountNumberInput.val();
        const countryCode = accountNumber.substring(0, 2);
        return this.oneTimeSurepayCountries.includes(countryCode);
    }

}

module.exports = { BankAccountPoller };